var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMarker',{key:_vm.hub.id,staticClass:"marker-style",attrs:{"position":_vm.hubCordinates,"clickable":true,"icon":this.selected ? require('./marker-hub-selected.png') :
                    this.hub.fav ? require('./marker-hub-fav.png')
                                 : require('./marker-hub.png')},on:{"click":function($event){return _vm.markerClick(_vm.hub)}}})}
var staticRenderFns = []

export { render, staticRenderFns }